import { ClientGroupCode } from '@domgen/dgx-fe-common';
import { GroupMarketingPreferencesFormConfig } from '../../models/group-marketing-preferences/group-marketing-preferences-form-config.interface';
import { mockCmsGroupMarketingPreferencesFieldset } from './cms-group-marketing-preferences-fieldset.mock';
import { mockGroupMarketingPreferencesFormValue } from './group-marketing-preferences-form-value.mock';

export const mockGroupMarketingPreferencesFormConfig: GroupMarketingPreferencesFormConfig =
  {
    groupCodes: [ClientGroupCode.Beko],
    cmsData: mockCmsGroupMarketingPreferencesFieldset,
    initialValue: mockGroupMarketingPreferencesFormValue,
  };
